<template>
    <v-dialog v-model="exibirModal" persistent max-width="600px">
        <v-card>
            <v-card-title class="modal_title primary white--text py-3" primary-title dark>
                <span class="headline">
                    <i class="fas fa-pause-circle mr-2" aria-hidden="true"/>
                    Compra Direta Suspensa
                </span>
                <v-spacer></v-spacer>
                <v-btn color="white" small icon flat @click="fecharModal">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="pt-4">
                <div class="text-center mb-3">
                    <v-icon color="warning" size="48">warning</v-icon>
                </div>
                
                <p class="text-center mb-4 body-1">
                    Esta compra direta foi suspensa e não é possível continuar com os lances.
                </p>
            </v-card-text>

            <v-card-actions class="px-4 pb-4">
                <v-spacer></v-spacer>
                <v-btn color="primary" depressed @click="fecharModal">
                    Fechar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ModalCompraSuspensa',
    props: {
        exibirModal: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        fecharModal() {
            this.$emit('fechar')
        }
    }
}
</script>

<style scoped>
.modal_title {
    border-radius: 4px 4px 0 0;
}

.headline {
    font-size: 1.25rem !important;
    font-weight: 500;
}

.v-card__text {
    padding: 24px;
}

.v-card__actions {
    padding: 16px 24px 24px;
}
</style>